import {SessionService, ISessionService} from './sessionService';

const app = angular.module('deliveryCreate.app');
app.service('SessionService', SessionService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/sessions/bootstrap.ts
 **/